import template from './group-invoices.html';
import controller from './group-invoices.controller';

let groupInvoicesComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default groupInvoicesComponent;
